module.exports = __webpack_public_path__ + "img/CreekRoadConsrvLocus_1_MOBILE.d17b0f63.png";